import React from "react";
import { Linkedin, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { IMAGES, CONTACT } from "../data/content";

const SPECIALISMS = [
  "Operational Strategy", "Operations Management", "Supply Chain", "Business Transformation",
  "Continuous Improvement", "Digital Transformation", "AI-enabled Improvement", "Performance Management",
  "People & Organisational Development", "Career Coaching",
];

export const Founder = () => {
  const go = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="founder" className="relative bg-white py-24 sm:py-32" data-testid="founder-section">
      <div className="mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-[0.8fr_1fr]">
        <Reveal>
          <div className="relative">
            <div className="relative overflow-hidden rounded-[2rem] card-shadow">
              <div className="emerald-radial relative aspect-[4/5] w-full">
                <div className="grain absolute inset-0" />
                <div className="absolute inset-x-0 bottom-0 top-1/2 bg-gradient-to-t from-emerald-darkest to-transparent" />
                <img src={IMAGES.founder} alt="Anthony Onwodi, Founder & Principal Consultant" className="absolute inset-x-0 bottom-0 mx-auto h-[96%] w-auto max-w-none object-contain object-bottom drop-shadow-2xl" />
              </div>
            </div>
            <div className="absolute -right-5 -top-5 hidden h-24 w-24 rounded-2xl border-2 border-gold sm:block" />
            <div className="absolute -bottom-6 left-6 right-6 rounded-2xl bg-emerald-base p-5 text-off-white shadow-xl">
              <p className="font-serif text-2xl">Anthony Onwodi</p>
              <p className="text-sm text-gold-light">Founder & Principal Consultant</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal><Overline>Founder</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
              A multidisciplinary consultant with a <span className="text-gradient-emerald">practical edge</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-charcoal/70">
              Anthony Onwodi is the Founder and Principal Consultant of OnwardTranscends. He works with organisations and
              professionals to solve complex operational, supply-chain and organisational challenges through practical,
              data-driven and people-focused consultancy.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-charcoal/70">
              His approach brings together operational excellence, supply chain expertise, Lean Six Sigma, digital
              transformation, artificial intelligence, organisational development and career coaching to help organisations
              and individuals achieve sustainable performance.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-2">
              {SPECIALISMS.map((s) => (
                <span key={s} className="rounded-full border border-emerald-base/15 px-3.5 py-1.5 text-xs font-medium text-emerald-base">{s}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" data-testid="founder-connect-btn"
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-emerald-base px-7 py-4 text-sm font-semibold text-off-white transition-transform duration-300 hover:-translate-y-1">
              <Linkedin size={18} /> Connect with Anthony
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
